import { render, staticRenderFns } from "./ChannelFee.vue?vue&type=template&id=223fa488"
import script from "./ChannelFee.vue?vue&type=script&lang=js"
export * from "./ChannelFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports